export const getNewsRes = state => state.getNews;
